export enum PickType {
    Unitary,
    Batch,
    Order,
    Unknow
}
